var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.sequence == 1)?_c('div',{staticStyle:{"height":"100%","text-align":"left"},attrs:{"id":"StackedCompanyName"}},[_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('span',_vm._g(_vm._b({staticClass:"white--text font-weight-regular"},'span',attrs,false),on),[_vm._v(" "+_vm._s(_vm.companyName)+" ")])]}}],null,false,3023903053)},[_c('span',[_vm._v(_vm._s(_vm.companyName))])])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }